import { save, get } from './storage'

const MKT_HREF_KEY = 'mkt::ref';

export const saveHref = ({ location }) => {
  const { href } = location;
  if (href?.includes('utm_') || href?.includes('amigo')) {
    save({ key: MKT_HREF_KEY, value: btoa(href) })
  }
}

export const getHref = () => {
  const value = get({ key: MKT_HREF_KEY })
  if (value) {
    return atob(value);
  }
  return null
}

export type AttributionSource = 'url' | 'storage' | 'none'

export interface ResolvedAttribution {
  href: string | null
  source: AttributionSource
}

// Existem links compartilhados com `amigo=` sem valor; `includes('amigo')` daria true neles.
const hasReferralCode = (href?: string | null): boolean => {
  if (!href) {
    return false
  }
  try {
    const amigo = new URL(href).searchParams.get('amigo')
    return Boolean(amigo) && amigo.trim() !== ''
  } catch (e) {
    return false
  }
}

// Os mesmos cinco que `ParseUTMFromURL` lê (signup/src/api/signup/dto/input.go:48-52).
const UTM_KEYS = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content']

const hasUtm = (href?: string | null): boolean => {
  if (!href) {
    return false
  }
  try {
    const params = new URL(href).searchParams
    return UTM_KEYS.some((key) => {
      const value = params.get(key)
      return Boolean(value) && value.trim() !== ''
    })
  } catch (e) {
    return false
  }
}

// Mais estrito que o gate do `saveHref`: exige valor, e não casa fragment nem substring.
const hasAttributionSignal = (href?: string | null): boolean =>
  hasReferralCode(href) || hasUtm(href)

// URL ao vivo primeiro, storage depois — UMA fonte só, nunca um mix de campos. Ver PR #283.
export const resolveAttribution = (): ResolvedAttribution => {
  const live = typeof window === 'undefined' ? null : window.location.href

  if (hasAttributionSignal(live)) {
    return { href: live, source: 'url' }
  }

  const stored = getHref()
  return { href: stored, source: stored ? 'storage' : 'none' }
}

export const getReferralCode = (href: string | null): string | null => {
  if (!href) {
    return null
  }

  try {
    return new URL(href).searchParams.get('amigo') || null
  } catch {
    return null
  }
}
